<template>
  <table class="table table-details">
    <tr>
      <td><label>{{ $t('operators.details.settings_stop_prefix') }}</label></td>
      <td>{{ details.stop_prefix }}</td>
    </tr>
  </table>
</template>
<script>

export default {
  name: 'operatorSettingsDetails',
  components: {},
  props: {
    details: {
      type: Object,
      required: true,
    },
  },
};
</script>
